import React from "react";

import { useTeamContext } from "../../../../contexts/TeamContext";

import deleteIcon from "images/icons/invite/delete.svg";
import editIcon from "images/icons/invite/edit.svg";

import Tooltip from "../../../ui/Tooltip";

export default function Actions({ row }) {
  const { dispatch, actions, state } = useTeamContext();

  const editItem = (e, row) => {
    actions.editTeam(row.attributes.enterprise_id, row.id);
  };

  const deleteItem = (e, row) => {
    const target = e.currentTarget;

    swal(
      {
        title: "",
        text: "Do you want to delete this team?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          target.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.removeTeam(dispatch, row, function () {
            swal({
              title: "Team Deleted!",
              text: "",
              html: true,
              type: "success",
              showCancelButton: false,
              confirmButtonText: "Close",
              closeOnConfirm: true,
            });
          });
        }
      }
    );
  };

  return (
    <>
      <a
        data-tip="Edit Team"
        onClick={(e) => editItem(e, row)}
        className="mr10"
      >
        <img src={editIcon} />
      </a>
      {!row.attributes.is_default && (
        <a data-tip="Delete Team" onClick={(e) => deleteItem(e, row)}>
          <img src={deleteIcon} />
        </a>
      )}
      <Tooltip />
    </>
  );
}
